import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  pure: true
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    maxLength: number = 20,
    defaultText: string = 'Guest'
  ): string {
    if (!value) {
      return defaultText;
    }

    // Truncate and add "..." if the length exceeds maxLength
    return value?.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
  }
}
